import { helpers } from 'vuelidate/lib/validators';

/**
 * Function used to check if the entered name is valid,
 * returns "true" if it is valid and "false" otherwise.
 * @param {string} value - the name to be validated
 * @returns {Boolean}
 */

export default function (value) {
  const validateFunction = helpers.regex('alpha', /^[A-Za-z\u00C0-\u024F\s']{2,64}$/);

  return validateFunction(value);
};
